import { Alert, AlertTitle } from '@material-ui/lab';
import React from 'react';
import Link from '@material-ui/core/Link';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { markNotificationAsRead, removeNotificationAlertAction } from '../../reducers/auth';

const PatientDeletedAlert = ({ id, patientName, caseNumber, organizationId, organizationName }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const handleAlertClose = () => {
    dispatch(removeNotificationAlertAction(id));
    dispatch(markNotificationAsRead(id));
  };

  const handleLinkClick = e => {
    e.preventDefault();
    history.push(`/organizations/${organizationId}`);
  };

  return (
    <Alert severity="info" key={id} onClose={handleAlertClose}>
      <AlertTitle>Case Deleted</AlertTitle>

      <span>Patient: {patientName}, &nbsp;</span>
      <span>{caseNumber ? `Case Number: ${caseNumber}, ` : ''} &nbsp;</span>
      <span>
        Organization: &nbsp;
        <Link href="#" onClick={handleLinkClick}>{organizationName}</Link>
      </span>
    </Alert>
  );
};

PatientDeletedAlert.propTypes = {
  id: PropTypes.string.isRequired,
  patientName: PropTypes.string.isRequired,
  caseNumber: PropTypes.string,
  organizationId: PropTypes.number.isRequired,
  organizationName: PropTypes.string.isRequired
};

PatientDeletedAlert.defaultProps = {
  caseNumber: null
};

export default PatientDeletedAlert;
